import PageHeader from "@/components/PageHeader";
import DataTable from "@/components/DataTable";
import { StatusBadge } from "@/components/StatusBadge";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ScrollText } from "lucide-react";

export default function AuditLogs() {
  const activityCols = [
    { key: "timestamp", label: "Time", render: (r) => new Date(r.timestamp).toLocaleString() },
    { key: "user_name", label: "User" },
    { key: "action", label: "Action", render: (r) => <StatusBadge status={r.action} /> },
    { key: "module", label: "Module", render: (r) => <span className="capitalize">{r.module}</span> },
    { key: "description", label: "Description" },
    { key: "ip", label: "IP", mono: true },
  ];

  const loginCols = [
    { key: "timestamp", label: "Time", render: (r) => new Date(r.timestamp).toLocaleString() },
    { key: "email", label: "Email", mono: true },
    { key: "status", label: "Result", render: (r) => <StatusBadge status={r.status === "success" ? "ok" : "critical"} /> },
    { key: "ip", label: "IP Address", mono: true },
    { key: "browser", label: "Device / Browser", render: (r) => <span className="text-xs text-slate-400 max-w-xs truncate block">{r.browser}</span> },
  ];

  return (
    <div>
      <PageHeader title="Audit & Activity Logs" subtitle="Complete traceability of every change and login" icon={ScrollText}
        breadcrumb={["Home", "Administration", "Audit"]} />
      <Tabs defaultValue="activity">
        <TabsList className="mb-4">
          <TabsTrigger value="activity" data-testid="tab-activity">Activity Log</TabsTrigger>
          <TabsTrigger value="login" data-testid="tab-login">Login History</TabsTrigger>
        </TabsList>
        <TabsContent value="activity">
          <DataTable endpoint="/activity-logs" columns={activityCols} testId="activity-table" searchable={false} />
        </TabsContent>
        <TabsContent value="login">
          <DataTable endpoint="/login-history" columns={loginCols} testId="login-table" searchable={false} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
